import ButtonControl from "../../components/ButtonControl"
import CAccordion from "../../components/CAccordion"
import InputItem from "../../components/InputItem"
import { IPWhitelistEntry } from "../../api/ip/data"

interface IPWhitelistItemProps {
    entry: IPWhitelistEntry
    onDelete?: (ip: string) => void
}

const IPWhitelistItem = ({
    entry,
    onDelete = (ip: string) => {},
}: IPWhitelistItemProps) => {
    const formatDate = (dateString: string) => {
        const date = new Date(dateString)
        return date.toLocaleString()
    }
    
    return <CAccordion label={entry.ip}>
        <InputItem edit={false} text="IP Address" value={entry.ip}/>
        <InputItem edit={false} text="Added At" value={formatDate(entry.addedAt)}/>
        <InputItem edit={false} text="Added By" value={entry.addedBy}/>
        {entry.description && <InputItem edit={false} text="Description" value={entry.description}/>}
        <ButtonControl 
            labelColor="red" 
            text="Remove from Whitelist" 
            variant="outline-danger" 
            buttonLabel="Remove" 
            onClicked={() => onDelete(entry.ip)}
        />
    </CAccordion>
}

export default IPWhitelistItem